function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GridUtils } from '@deephaven/grid';
import memoizeOne from 'memoize-one';
import Log from '@deephaven/log';
var log = Log.module('ColumnHeaderGroup');
export function isColumnHeaderGroup(x) {
  return x instanceof ColumnHeaderGroup;
}
export default class ColumnHeaderGroup {
  constructor(_ref) {
    var name = _ref.name,
      children = _ref.children,
      color = _ref.color,
      depth = _ref.depth,
      childIndexes = _ref.childIndexes,
      parent = _ref.parent;
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "children", void 0);
    _defineProperty(this, "depth", void 0);
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "color", void 0);
    _defineProperty(this, "childIndexes", void 0);
    _defineProperty(this, "getVisibleRange", memoizeOne(movedItems => {
      var flattenedIndexes = this.childIndexes.flat();
      var visibleIndexes = GridUtils.getVisibleIndexes(flattenedIndexes, movedItems);
      var start = Math.min(...visibleIndexes);
      var end = Math.max(...visibleIndexes);
      if (end - start !== flattenedIndexes.length - 1) {
        log.warn("Column header group ".concat(this.name, " is not contiguous"));
      }
      return [start, end];
    }));
    this.name = name;
    this.children = children;
    this.color = color !== null && color !== void 0 ? color : undefined;
    this.depth = depth;
    this.childIndexes = childIndexes;
    this.parent = parent;
  }
  setParent(parent) {
    this.parent = parent;
  }
  addChildren(children) {
    var newChildren = new Set(this.children.concat(children));
    this.children = [...newChildren];
  }
  removeChildren(children) {
    var newChildren = new Set(this.children);
    children.forEach(name => newChildren.delete(name));
    this.children = [...newChildren];
  }
  get isNew() {
    return this.name.startsWith(ColumnHeaderGroup.NEW_GROUP_PREFIX);
  }

  /**
   * Checks if a group is valid.
   * An invalid group needs to be re-parsed with the corresponding model.
   * @returns true if the group is valid (all children have indexes)
   */
  isValid() {
    return this.children.length === this.childIndexes.length;
  }
}
_defineProperty(ColumnHeaderGroup, "NEW_GROUP_PREFIX", ':newGroup');
//# sourceMappingURL=ColumnHeaderGroup.js.map